import { formatProductRating } from "../../utils/format";
import type { TextualDisplayValue } from "@ebay/experience-types-ebay";
import type { Locality } from "@ebay/locale-ebay";
import type { MapContext } from "../map/types";
export interface Input {
  productRating?: TextualDisplayValue;
  sellerName?: TextualDisplayValue;
  sellerRating?: TextualDisplayValue;
  locality?: Locality;
}
$ const {
  productRating,
  sellerName,
  sellerRating,
  locality: localityInput,
} = input;
$ const productRatingValue = productRating?.value as unknown as number;

<context|ctx| from="map">
  $ const { locality: localityCtx } = (ctx || {}) as MapContext;
  $ const locality = localityInput || localityCtx;
  <div class="item-seller">
    <if(productRatingValue)>
      <p class="item-seller-product-rating">
        <ebay-star-filled-16-icon/>
        ${formatProductRating(productRatingValue, locality?.locale)}
      </p>
    </if>
    <if(sellerName)>
      <p class="item-seller-name">
        <fe-textual-display model=sellerName/>
      </p>
    </if>
    <if(sellerRating)>
      <p class="item-seller-rating">
        <fe-textual-display model=sellerRating/>
      </p>
    </if>
  </div>
</context>
